import { render, staticRenderFns } from "./ClimateDetails.vue?vue&type=template&id=21cfe9a9&"
import script from "./ClimateDetails.vue?vue&type=script&lang=js&"
export * from "./ClimateDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports